import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SatPopoverModule } from '@ncstate/sat-popover';
import { MaterialModule } from './../material.module';
import { AppRoutingModule } from './../app-routing.module';
import { DndModule } from 'ngx-drag-drop';

// modules
import { PipesModule } from './../pipes/pipes.module';

// pages
import {
  LoginComponent,
  SetResetUserPinComponent,
  AuthUserPinComponent,
  PageNotFoundComponent,
  PasswordUpdateComponent,
  TotalPageItemsComponent,
  ConnectionLostComponent,
  CertificatesComponent,
  PrivateCertificatesComponent,
  PendingCertificatesComponent,
  DialogPrivateCertUploadComponent,
  DialogPrivateCertDestroyComponent,
  DialogPendingCertDeleteComponent,
  DialogPrivateCertRegeneratePinComponent,
  DialogPrivateCertEditPinComponent,
  DialogPrivateCertRemovePin2Component,
  DialogPendingCertActivateComponent,
  DialogConfirmFpBackupComponent,
  WebSignComponent,
  SigntrustPdfViewerComponent,
  PdfViewerComponent,
  CertificatesListComponent,
  ConfirmationDialog,
  DialogSignCertViewDetailsComponent,
  DialogStaticNotificationsComponent,
  DialogConfirmDownloadComponent,
  DialogDocumentInfoComponent,
  DialogSelectCertificateComponent,
  DialogConfirmPinReasonComponent,
  EditSignatureConfigComponent,
} from './index.pages';
import { DirectiveModule } from './../directive/directive.module';
import { ToastrCustomActionComponent } from './common/toastr-custom-action/toastr-custom-action.component';
import { environment } from '@environments/environment';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    providers: [
      {
        provide: 'environment',
        useValue: environment,
      },
    ],
    declarations: [
        LoginComponent,
        SetResetUserPinComponent,
        AuthUserPinComponent,
        PageNotFoundComponent,
        PasswordUpdateComponent,
        TotalPageItemsComponent,
        ConnectionLostComponent,
        CertificatesComponent,
        PrivateCertificatesComponent,
        PendingCertificatesComponent,
        DialogPrivateCertUploadComponent,
        DialogPrivateCertDestroyComponent,
        DialogPendingCertDeleteComponent,
        DialogPrivateCertRegeneratePinComponent,
        DialogPrivateCertEditPinComponent,
        DialogPrivateCertRemovePin2Component,
        DialogPendingCertActivateComponent,
        DialogConfirmFpBackupComponent,
        ToastrCustomActionComponent,
        WebSignComponent,
        SigntrustPdfViewerComponent,
        PdfViewerComponent,
        CertificatesListComponent,
        ConfirmationDialog,
        DialogSignCertViewDetailsComponent,
        DialogStaticNotificationsComponent,
        DialogConfirmDownloadComponent,
        DialogDocumentInfoComponent,
        DialogSelectCertificateComponent,
        DialogConfirmPinReasonComponent,
        EditSignatureConfigComponent,
    ],
    exports: [
        TranslateModule,
        DndModule,
        LoginComponent,
        SetResetUserPinComponent,
        AuthUserPinComponent,
        PageNotFoundComponent,
        PasswordUpdateComponent,
        TotalPageItemsComponent,
        ConnectionLostComponent,
        CertificatesComponent,
        PrivateCertificatesComponent,
        PendingCertificatesComponent,
        DialogPrivateCertUploadComponent,
        DialogPrivateCertDestroyComponent,
        DialogPendingCertDeleteComponent,
        DialogPrivateCertRegeneratePinComponent,
        DialogPrivateCertEditPinComponent,
        DialogPrivateCertRemovePin2Component,
        DialogPendingCertActivateComponent,
        DialogConfirmFpBackupComponent,
        DialogConfirmPinReasonComponent,
        ToastrCustomActionComponent
    ],
    imports: [
        DndModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        SatPopoverModule,
        DirectiveModule,
        AppRoutingModule,
        MaterialModule,
        CommonModule,
        PipesModule,
        TranslateModule
    ]
})
export class PagesModule { }

